import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white px-2 py-1 flex justify-between overflow-hidden duration-500 transition-all"
}
const _hoisted_2 = { class: "flex flex-wrap" }
const _hoisted_3 = { class: "bg-gray-100 border rounded-full text-sm font-medium py-1 px-3 whitespace-nowrap select-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.toArray(_ctx.tags).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                class: "p-1"
              }, [
                _createVNode(_component_router_link, {
                  to: { path: '/video', query: _ctx.toTagIdsQuery(item.id)}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}